<template>
  <m-card
    v-bind="$attrs"
    v-on="$listeners">
    <slot />
  </m-card>
</template>

<script>
import Vue from 'vue'
import Card from 'material-components-vue/dist/card'
Vue.use(Card)

export default {
  props: {},
  data () {
    return {}
  }
}
</script>

<style lang="scss">
  @import '../../universal/vars.scss';
  @import "material-components-vue/dist/card/styles";
</style>
